<template>
    <b-card>
      <b-tabs v-model="tabIndex" align="left" class="tab-primary">
        <b-tab>
          <template #title>
            <div class="tab-title">
              <span> {{$t('Notificaciones')}} </span>
            </div>
          </template>
          <notifications></notifications>
        </b-tab>
        <b-tab :lazy="isLazy.surveys" @click="showTab('surveys')">
          <template #title>
            <div>
              <span> {{$t('Encuestas')}} </span>
            </div>
          </template>
          <surveys></surveys>
        </b-tab>
      </b-tabs>
    </b-card>
</template>
<script>
import notifications from './modules/Notifications.vue'
import surveys from './modules/Surveys.vue'
export default {
  components: { notifications, surveys },
  data () {
    return {
      tabIndex: 0,
      isLazy: {
        surveys: true
      }
    }
  },
  methods: {
    showTab(name) {
      if (this.isLazy[name]) this.isLazy[name] = false
    }
  }
}
</script>